import { Spin } from "antd";
import React from "react";

export default function InitialValueRendering({ error, loading }) {
  if (loading) return <LoadingComp />;
  if (error) return <div>{JSON.stringify(error)}</div>;
  return <div>Nothing to show</div>;
}

const LoadingComp = () => (
  <div className="d-flex align-items-center justify-content-center my-2">
    <Spin />
  </div>
);
